import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthenticationService } from '../authentication/authentication.service';
var AuthorizationGuard = /** @class */ (function () {
    function AuthorizationGuard(router, authService, oidcSecurityService) {
        this.router = router;
        this.authService = authService;
        this.oidcSecurityService = oidcSecurityService;
    }
    AuthorizationGuard.prototype.canActivate = function (route, state) {
        return this.checkUser(state);
    };
    AuthorizationGuard.prototype.canLoad = function (state) {
        return this.checkUser();
    };
    AuthorizationGuard.prototype.checkUser = function (state) {
        var _this = this;
        if (state === void 0) { state = null; }
        // Get the hash value of the URL if we have already loged in.
        var hash = window.location.hash.substring(1);
        var params = hash.split('&')
            .map(function (v) { return v.split('='); })
            .reduce(function (pre, _a) {
            var key = _a[0], value = _a[1];
            var _b;
            return (tslib_1.__assign({}, pre, (_b = {}, _b[key] = value, _b)));
        }, {});
        // This condition will run the first time after we press Sign In through B2C to check if we have already loged in.
        if (params['access_token']) {
            return true;
        }
        // This will run after B2C return the URL (our app's URL) for us to redirect to the app and also to authenticate the token.
        return this.oidcSecurityService.getIsAuthorized().pipe(map(function (isAuth) {
            var isPreRegistration = JSON.parse(localStorage.getItem('isPreRegistration'));
            if (isAuth && !isPreRegistration) {
                // Those lines of code inside the dashes concatenated below,
                // are in the Work Around ticket PECLP-627: [Chrome] Timeout - Cause the tab browser hang
                // ---------------------------------------------------------------------------
                if (_this.authService.isTokenNotExpired()) {
                    return true;
                }
                // In case the user is not logged in yet. We still save the current URL,
                // after login successfully, the system will bring the user to it.
                _this.tryUpdateLoginCallbackUrl(state);
                // Consider to use this.oidcSecurityService.logoff(),
                // If we update the library angular-auth-oidc-client to version 11 or greater.
                // And update Angular version to 8 or greater.
                // For now, we use the line code below to redirect to home page if the token expired.
                _this.authService.logout();
                return false;
                // ---------------------------------------------------------------------------
            }
            else {
                // In case the user is not logged in yet. We still save the current URL,
                // after login successfully, the system will bring the user to it.
                _this.tryUpdateLoginCallbackUrl(state);
                // this.authService.login();
                _this.router.navigate(['home']);
                // window.location.href = `${environment.aadConfig.post_logout_redirect_uri}`;
                return false;
            }
        }));
    };
    AuthorizationGuard.prototype.tryUpdateLoginCallbackUrl = function (state) {
        if (state && state.url.includes('/request/')) {
            localStorage.setItem('callback_url', state.url);
        }
    };
    return AuthorizationGuard;
}());
export { AuthorizationGuard };
